module.exports = __webpack_public_path__ + "img/instagram.dba02aec.svg";